/**
 * Notification and Entity type definitions matching backend enums
 */

export enum NotificationType {
  COMMENT = 'comment',
  UPVOTE = 'upvote',
  DOWNVOTE = 'downvote',
  SHARE = 'share',
  INVITE = 'invite',
  REVIEW = 'review',
  POST = 'post',
  REPLY = 'reply',
  REPORT = 'report',
  REPORT_REJECT = 'report_reject',
  ITEM_SOLD = 'item_sold',
  PARTNERSHIP_REQUESTED = 'partnership_requested',
  PARTNERSHIP_ACCEPTED = 'partnership_accepted',
  CREATE_BUSINESS = 'create_business',
  NEW_BUSINESS_DISCOUNT = 'new_business_discount',
  JOIN_GROUP = 'join_group',
  ACCEPT_INVITATION = 'accept_invitation',
}

export enum EntityType {
  POST = 'post',
  ITEM = 'item',
  PROVIDER = 'provider',
  REQUEST_PROVIDER = 'request',
  BUSINESS = 'business',
  EDUCATION = 'education',
  GROUP = 'group',
  COMMENT = 'comment',
  USER = 'user',
}

// Type definitions for better TypeScript support
export type NotificationTypeValue = `${NotificationType}`;
export type EntityTypeValue = `${EntityType}`;
